import { render, staticRenderFns } from "./UnidadeGestora.vue?vue&type=template&id=63d24f30"
import script from "./UnidadeGestora.vue?vue&type=script&lang=js"
export * from "./UnidadeGestora.vue?vue&type=script&lang=js"
import style0 from "./UnidadeGestora.vue?vue&type=style&index=0&id=63d24f30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports